module.exports = __webpack_public_path__ + "static/media/backward.83edf30a.svg";